import { render, staticRenderFns } from "./PaymentMethodsList.vue?vue&type=template&id=61dcbde6&scoped=true&"
import script from "./PaymentMethodsList.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodsList.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentMethodsList.vue?vue&type=style&index=0&id=61dcbde6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dcbde6",
  null
  
)

export default component.exports